import React, {
  useState
} from 'react';

import {
  ExternalLink,
  RefreshCw,
  MessageSquareText,
  ShieldCheck
} from 'lucide-react';


export const ChatGPTPage:
React.FC = () => {

  const [
    frameKey,
    setFrameKey
  ] =
    useState(
      0
    );


  const openExternal =
    () => {

      window.open(
        'https://chatgpt.com',
        '_blank',
        'noopener,noreferrer'
      );
    };


  return (
    <div
      className="
        flex flex-col
        min-w-0
        h-[calc(100dvh-7.5rem)]
        md:h-[calc(100vh-8rem)]
        md:min-h-[560px]
        gap-3
      "
    >

      {/* Page identity */}
      <div
        className="
          shrink-0
          flex items-center justify-between
          gap-3
          px-0.5
        "
      >

        <div className="flex items-center gap-2.5 min-w-0">

          <div
            className="
              w-8 h-8
              shrink-0
              rounded-xl
              flex items-center justify-center
              border border-indigo-400/20
              bg-slate-900
              text-indigo-300
              shadow-[0_10px_30px_rgba(15,23,42,0.16)]
            "
          >
            <MessageSquareText className="w-4 h-4" />
          </div>


          <div className="min-w-0">

            <h2
              className="
                text-lg sm:text-xl
                font-bold
                text-slate-900
                tracking-tight
              "
            >
              ChatGPT
            </h2>

            <p className="text-[10px] sm:text-xs text-slate-500 truncate">
              Direct ChatGPT workspace inside KAIZEN Remote
            </p>

          </div>

        </div>


        <button
          type="button"
          onClick={
            openExternal
          }
          className="
            shrink-0
            inline-flex items-center justify-center
            gap-1.5
            min-h-[38px]
            px-3
            rounded-lg
            border border-slate-200
            bg-white/80
            hover:bg-white
            text-[10px] sm:text-xs
            font-semibold
            text-slate-700
            shadow-sm
            backdrop-blur-xl
            transition-colors
          "
        >

          <ExternalLink className="w-3.5 h-3.5" />

          <span className="hidden sm:inline">
            Open in ChatGPT
          </span>

          <span className="sm:hidden">
            Open
          </span>

        </button>

      </div>


      {/* Embedded ChatGPT shell */}
      <div
        className="
          relative
          flex-1 min-h-0
          overflow-hidden
          rounded-[18px]
          border border-slate-700/80
          bg-slate-950
          shadow-[0_24px_70px_rgba(2,6,23,0.30)]
        "
      >

        {/* Ambient illumination */}
        <div
          aria-hidden="true"
          className="
            pointer-events-none
            absolute
            -top-24 left-1/2
            h-64 w-64
            -translate-x-1/2
            rounded-full
            bg-indigo-500/10
            blur-3xl
          "
        />


        {/* Mini browser toolbar */}
        <div
          className="
            relative z-10
            h-11
            shrink-0
            flex items-center justify-between
            gap-3
            px-3
            border-b border-white/[0.07]
            bg-slate-900/88
            backdrop-blur-2xl
          "
        >

          <div className="flex items-center gap-2 min-w-0">

            <div className="hidden sm:flex items-center gap-1.5 shrink-0">
              <span className="w-2 h-2 rounded-full bg-rose-400/60" />
              <span className="w-2 h-2 rounded-full bg-amber-400/60" />
              <span className="w-2 h-2 rounded-full bg-emerald-400/60" />
            </div>


            <div
              className="
                flex items-center gap-2
                min-w-0
                px-2.5 py-1
                rounded-md
                border border-white/[0.06]
                bg-black/15
              "
            >

              <ShieldCheck className="w-3 h-3 shrink-0 text-emerald-400" />

              <span
                className="
                  truncate
                  font-mono
                  text-[9px] sm:text-[10px]
                  text-slate-400
                "
              >
                https://chatgpt.com
              </span>

            </div>

          </div>


          <button
            type="button"
            onClick={
              () =>
                setFrameKey(
                  previous =>
                    previous + 1
                )
            }
            title="Reload ChatGPT frame"
            className="
              w-8 h-8
              shrink-0
              flex items-center justify-center
              rounded-md
              text-slate-400
              hover:text-slate-100
              hover:bg-white/[0.05]
              transition-colors
            "
          >

            <RefreshCw className="w-3.5 h-3.5" />

          </button>

        </div>


        {/* ChatGPT */}
        <iframe
          key={
            frameKey
          }
          src="https://chatgpt.com/"
          title="ChatGPT"
          allow="
            microphone;
            camera;
            clipboard-read;
            clipboard-write;
            fullscreen
          "
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
          className="
            relative z-0
            block
            w-full
            h-[calc(100%-2.75rem)]
            border-0
            bg-white
          "
        />

      </div>


      {/* Small non-intrusive fallback note */}
      <div
        className="
          shrink-0
          flex items-center justify-between
          gap-3
          px-1
          text-[9px] sm:text-[10px]
          text-slate-400
        "
      >

        <span className="truncate">
          Embedded mode uses ChatGPT directly — KAIZEN does not proxy your session.
        </span>


        <button
          type="button"
          onClick={
            openExternal
          }
          className="
            shrink-0
            text-indigo-500
            hover:text-indigo-600
            font-semibold
          "
        >
          Open externally
        </button>

      </div>

    </div>
  );
};